module.exports = __webpack_public_path__ + "static/media/background9.373ff34b.png";